export const BrandRouting = [
  {
    path: "/material/brand/list",
    name: "basic-material-brand-list",
    meta: { title: "品牌管理" },
    component: () =>
      import(
        /* webpackChunkName: "basic-material-brand" */ "@/views/material/brand/list/index.vue"
      ),
  },
];
